// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"df6388c9","748":"1c936477"}[chunkId] + ".chunk.js";
};